<template>
<div class="w-85per dp-inblock">
    <div class="title">
        <h2>신청 안내</h2>
        <p>
            - <span class="txt-red">신청 전 필요한 정보(수료기준, 과정, 교재, 우수학습자 선정기준 등)</span>을 상세히 적어주세요. <br>
            - 이미지는 830px 이내로 등록해주세요. <br>
            - 다운로드 파일 2MB 이하 pdf, pptx, docx, xlsx, hwp, jpg, png
        </p>
    </div>
    <div class="h-50px">
        <button class="admin-btn-default float-right mb-10" @click="insertDefaultTag()">기본문구</button>
    </div>
    <ckeditor :parentData="editorData" v-model="editorData"></ckeditor>
    <table class="admin-table-row">
        <thead>
            <tr>
                <th width="150">다운로드 버튼1</th>
                <td>
                    <input type="text" v-model="buttonName1" placeholder="20자 내외로 입력" class="w-200px">
                    <div class="filebox dp-in ml-05">
                        <input type="file" ref="firstFile" id="firstFile" class="w-200px" @change="selectFirstFile($event)">
                        <input class="upload-name w-200px" disabled placeholder="파일을 업로드 해주세요" :value="selectedFirstFileName">
                        <label class="w-100px font-14" @click="$refs.firstFile.click()">파일 선택</label>
                        <label class="w-100px font-14" @click="deleteFile('button1')">삭제</label>
                    </div>
                </td>
            </tr>
            <tr>
                <th width="150">다운로드 버튼2</th>
                <td>
                    <input type="text" v-model="buttonName2" placeholder="20자 내외로 입력" class="w-200px">
                    <div class="filebox dp-in ml-05">
                        <input type="file" ref="secondFile" id="secondFile" class="w-200px" @change="selectSecondFile($event)">
                        <input class="upload-name w-200px" disabled placeholder="파일을 업로드 해주세요" :value="selectedSecondFileName">
                        <label class="w-100px font-14" @click="$refs.secondFile.click()">파일 선택</label>
                        <label class="w-100px font-14" @click="deleteFile('button2')">삭제</label>
                    </div>
                </td>
            </tr>
            <tr v-if="isViewDownPostion()">
                <th width="150">다운로드버튼 위치</th>
                <td>
                    <label for="cancle">
                        <input type="radio" v-model="buttonPosition" value="T" name="button" id="">
                        <span class="txt-13px ml-05 mr-20">Top</span>
                    </label>
                    <label for="cancle">
                        <input type="radio" v-model="buttonPosition" value="B" name="button" id="">
                        <span class="txt-13px ml-05 mr-20">Bottom</span>
                    </label>
                </td>
            </tr>
        </thead>
    </table>
    <div class="line"></div>
    <div class="mt-30 w-100per mg-auto">
        <button @click="prev()" class="admin-btn-default">이전</button>
        <button @click="next()" class="admin-btn-default float-right ml-05">
            <span v-if="isFinishPage">완료하기</span>
            <span v-else>다음</span>
        </button>
        <button @click="save()" class="admin-btn-default float-right ml-05">저장</button>
        <button @click="preview()" class="admin-btn-default float-right">미리보기</button>
    </div>
</div>
</template>

<script>
import Ckeditor from '@/components/utils/ckEditor.vue'
export default {
    data: () => ({
        editorData: '', // 에디터 default 내용

        buttonName1: '', // 다운로드 버튼1 버튼명 
        buttonName2: '', // 다운로드 버튼2 버튼명
        buttonPosition: 'T', // 버튼 위치

        selectedFirstFiles: '', // 선택된 첫번째 파일 
        completeFirstFile: '', // api에 넣을 첫번째 데이터
        selectedFirstFileName: '', // 선택된 첫번째 파일 이름 
        selectedSecondFiles: '', // 선택된 두번째 파일 
        completeSecondFile: '', // api에 넣을 두번째 파일 데이터
        selectedSecondFileName: '', // 선택된 두번째 파일 이름

        isSaved: false, // 저장 여부
        isFinishPage: false, // 현재 페이지가 마지막 페이지인지
        buttonFileDelete1: false, // 다운로드파일1 삭제여부
        buttonFileDelete2: false, // 다운로드파일2 삭제여부
    }),
    components: {
        Ckeditor
    },

    mounted() {
        if (sessionStorage.getItem('fix')) {
            var summaryIdx = sessionStorage.getItem('mainIdx')
            var params = {
                summaryIdx: summaryIdx
            }
            this.axios.get(this.axios.root + this.axios.port + `/sugang/guide/${summaryIdx}`, params)
                .then(res => {
                    console.log('res', res)
                    this.editorData = res.data.guideInfo.guide_contents
                    this.buttonName1 = res.data.guideInfo.button_name1
                    this.buttonName2 = res.data.guideInfo.button_name2
                    
                    // 등록시 첫번째 파일을 업로드 한 경우에만 변수에 데이터 할당
                    if (res.data.guideInfo.button_file_name1) {
                        this.selectedFirstFileName = res.data.guideInfo.button_file_name1
                    }

                    // 등록시 두번째 파일을 업로드 한 경우에만 변수에 데이터 할당
                    if (res.data.guideInfo.button_file_name2) {
                        this.selectedSecondFileName = res.data.guideInfo.button_file_name2
                    }
                    
                    // 등록시 파일을 한 개라도 업로드 한 경우에만 변수에 데이터 할당
                    if (res.data.guideInfo.button_position) {
                        this.buttonPosition = res.data.guideInfo.button_position
                    }
                }).catch(err => {
                    console.log(err)
                    alert(err)
                })
        }

        var pathArray = this.$route.fullPath.split('/')
        var length = pathArray.length
        var pageType = pathArray[length - 1]
        var pOrder = JSON.parse(sessionStorage.getItem('pOrder'))
        var finishPage = pOrder[pOrder.length - 1]

        if (pageType === finishPage) {
            this.isFinishPage = true
        }
    },

    methods: {
        // 미리보기
        preview() {
            if (!this.isSaved) {
                alert('미리보기를 하려면 먼저 저장을 해야합니다.')
                return false
            }
            let routeData = this.$router.resolve({
                name: 'preview-info',
                query: {
                    mainIdx: sessionStorage.getItem('mainIdx')
                }
            });
            window.open(routeData.href, '_blank');
        },

        // 이전 페이지 이동
        prev() {
            var pOrder = JSON.parse(sessionStorage.getItem("pOrder"));
            var idx = pOrder.indexOf('info') - 1
            this.$router.push(`/admin/reg/${pOrder[idx]}`)
            // this.$router.push('/admin/reg/agree')
        },

        // 다음 페이지 이동
        async next() {
            if (this.isSaved) {
                if (this.isFinishPage) {
                    alert('수강신청 등록이 완료되었습니다.')
                    this.$router.push('/admin/list/main')
                } else {
                    var pOrder = JSON.parse(sessionStorage.getItem("pOrder"));
                    var idx = pOrder.indexOf('info') + 1
                    sessionStorage.setItem('step', pOrder[idx])
                    this.$router.push(`/admin/reg/${pOrder[idx]}`)
                }
            } else {
                alert('저장을 먼저 해주세요.')
                return false
            }
        },

        // CK에디터에 기본 문구 삽입
        insertDefaultTag() {
            this.editorData = '<div style="width:600px;"><div style="font-weight: bold; font-size: 16px; margin-bottom: 10px; letter-spacing: -1px;">■ 일정</div><table style="width: 100%; border-top: 2px solid #000000; font-size: 14px;" cellpadding= "0" cellspacing= "0">    <tr>        <th style="border-bottom: 1px solid #e5e5e5; width: 100px; padding: 5px 10px; text-align: center; background: #f5f5f5;">수강 신청</th>        <td style="border-bottom: 1px solid #e5e5e5; padding: 10px 20px;">5.15(월) 10:00 ~ 6.17(수) 20:00 까지</td>    </tr>    <tr>        <th style="border-bottom: 1px solid #e5e5e5; width: 100px; padding: 5px 10px; text-align: center; background: #f5f5f5;">레벨 테스트</th>        <td style="border-bottom: 1px solid #e5e5e5; padding: 10px 20px;">5.15(월) ~ 5.16(화)</td>    </tr>    <tr>        <th style="border-bottom: 1px solid #e5e5e5; width: 100px; padding: 5px 10px; text-align: center; background: #f5f5f5;">입과 안내</th>        <td style="border-bottom: 1px solid #e5e5e5; padding: 10px 20px;">7.2(목)</td>    </tr>    <tr>        <th style="border-bottom: 1px solid #e5e5e5; width: 100px; padding: 5px 10px; text-align: center; background: #f5f5f5;">수강 기간</th>        <td style="border-bottom: 1px solid #e5e5e5; padding: 10px 20px;">7.6(목) ~ 9.3(목)</td>    </tr></table></div><div style="margin-top: 20px;width:600px;"><div style="font-weight: bold; font-size: 16px; margin-bottom: 10px; letter-spacing: -1px;"><br>■ 개요</div><table style="width: 100%; border-top: 2px solid #000000; font-size: 14px;" cellpadding= "0" cellspacing= "0">    <tr>        <th style="border-bottom: 1px solid #e5e5e5; width: 100px; padding: 5px 10px; text-align: center; background: #f5f5f5;">대상</th>        <td style="border-bottom: 1px solid #e5e5e5; padding: 10px 20px;">글로벌 업무 유관 직원 중 희망자</td>    </tr>    <tr>        <th style="border-bottom: 1px solid #e5e5e5; width: 100px; padding: 5px 10px; text-align: center; background: #f5f5f5;">목표</th>        <td style="border-bottom: 1px solid #e5e5e5; padding: 10px 20px;">비즈니스 상황에서 커뮤니케이션 향상</td>    </tr>    <tr>        <th style="border-bottom: 1px solid #e5e5e5; width: 100px; padding: 5px 10px; text-align: center; background: #f5f5f5;">언어</th>        <td style="border-bottom: 1px solid #e5e5e5; padding: 10px 20px;">영어, 중국어</td>    </tr>    <tr>        <th style="border-bottom: 1px solid #e5e5e5; width: 100px; padding: 5px 10px; text-align: center; background: #f5f5f5;">과정</th>        <td style="border-bottom: 1px solid #e5e5e5; padding: 10px 20px;">Business Conversation / Writing / Discussion</td>    </tr>    <tr>        <th style="border-bottom: 1px solid #e5e5e5; width: 100px; padding: 5px 10px; text-align: center; background: #f5f5f5;">형태</th>        <td style="border-bottom: 1px solid #e5e5e5; padding: 10px 20px;">1:N Group / 1:1 Language Lab</td>    </tr>    <tr>        <th style="border-bottom: 1px solid #e5e5e5; width: 100px; padding: 5px 10px; text-align: center; background: #f5f5f5;">장소</th>        <td style="border-bottom: 1px solid #e5e5e5; padding: 10px 20px;">00000 본사 3층 강의실</td>    </tr>    <tr>        <th style="border-bottom: 1px solid #e5e5e5; width: 100px; padding: 5px 10px; text-align: center; background: #f5f5f5;">기타</th>        <td style="border-bottom: 1px solid #e5e5e5; padding: 10px 20px;"></td>    </tr></table></div><div style="margin-top: 20px;width:600px;"><div style="font-weight: bold; font-size: 16px; margin-bottom: 10px; letter-spacing: -1px;"><br>■ 수료기준</div><table style="width: 100%; border-top: 2px solid #000000; font-size: 14px;" cellpadding= "0" cellspacing= "0">    <tr>        <th style="border-bottom: 1px solid #e5e5e5; width: 100px; padding: 5px 10px; text-align: center; background: #f5f5f5;">출석률</th>        <td style="border-bottom: 1px solid #e5e5e5; padding: 10px 20px;">            * 80% 이상 달성 <br>            1) 출석(공결) 인정 <br>            - 40회 중 8회 인정(8회 초과할 시, 결석처리) <br>            - 경조사, 출장, 교육, 예비군/민방위 훈현 등 출석 인정 <br>            2) 불참사유서 제출 <br>            - ELP에 증빙서류 첨부하여 사진 제출    </td>    </tr>    <tr>        <th style="border-bottom: 1px solid #e5e5e5; width: 100px; padding: 5px 10px; text-align: center; background: #f5f5f5;">향샹도</th>        <td style="border-bottom: 1px solid #e5e5e5; padding: 10px 20px;">사전&사후 SPAC 응시</td>    </tr>    <tr>        <th style="border-bottom: 1px solid #e5e5e5; width: 100px; padding: 5px 10px; text-align: center; background: #f5f5f5;">미수료 패널티</th>        <td style="border-bottom: 1px solid #e5e5e5; padding: 10px 20px;">            - 10만원 급여 공제 <br>            - 차기 차수 입과 제한        </td>    </tr></table></div><div style="margin-top: 20px;width:600px;"><div style="font-weight: bold; font-size: 16px; margin-bottom: 10px; letter-spacing: -1px;"><br>■ 수료기준</div><table style="width: 100%; border-top: 2px solid #000000; font-size: 14px;" cellpadding= "0" cellspacing= "0">    <tr>        <th style="border-bottom: 1px solid #e5e5e5; width: 100px; padding: 5px 10px; text-align: center; background: #f5f5f5;">출석률</th>        <td style="border-bottom: 1px solid #e5e5e5; padding: 10px 20px;">2020.07.06(월) ~ 07.17(금) 2주</td>    </tr>    <tr>        <th style="border-bottom: 1px solid #e5e5e5; width: 100px; padding: 5px 10px; text-align: center; background: #f5f5f5;">변경 방법</th>        <td style="border-bottom: 1px solid #e5e5e5; padding: 10px 20px;">            - 과정 형태의 변경을 희망하는 경우 위 기간에 한해서 변경 가능 <br>            - 이후 취소 시, 미수료 처리 <br>            - 수강 신청 기간 내, 아래의 방법으로 취소 후 재신청 <br>            신청 내역 확인 -> 신청된 내역 클릭 후 취소 클릭 -> 신청 페이지 접속하여 재신청        </td>    </tr>    <tr>        <th style="border-bottom: 1px solid #e5e5e5; width: 100px; padding: 5px 10px; text-align: center; background: #f5f5f5;">기타</th>        <td style="border-bottom: 1px solid #e5e5e5; padding: 10px 20px;">기간 외 일정에는 취소/변경 불가합니다.</td>    </tr></table></div>'
        },

        // 첫번째 파일 선택 로직
        selectFirstFile(event) {
            this.selectedFirstFiles = this.$refs.firstFile.files;
            var allowFormat = ['pdf', 'pptx', 'docx', 'xlsx', 'hwp', 'jpg', 'png']
            var checked = false
            for (var item of allowFormat) {
                if (this.selectedFirstFiles[0].name.includes(item)) {
                    checked = true
                    break
                } else {
                    continue
                }
            }
            if (checked) {
                if (event.target.files[0].size > 2097152) {
                    alert('2MB 이하만 업로드 가능합니다.')
                    this.$refs.firstFile.value = ''
                    this.selectedFirstFiles = ''
                    return false
                }

                this.completeFirstFile = event.target.files[0];
                this.selectedFirstFileName = event.target.files[0].name;
                this.buttonFileDelete1 = false;

                this.$refs.firstFile.value = ''
            } else {
                alert('파일 포맷은 pdf, pptx, docx, xlsx, hwp, jpg, png형식만 가능합니다.')
                this.$refs.firstFile.value = ''
                this.selectedFirstFiles = ''
                return false
            }
        },

        // 두번째 파일 선택 로직
        selectSecondFile(event) {
            this.selectedSecondFiles = this.$refs.secondFile.files;
            var allowFormat = ['pdf', 'pptx', 'docx', 'xlsx', 'hwp', 'jpg', 'png']
            var checked = false
            for (var item of allowFormat) {
                if (this.selectedSecondFiles[0].name.includes(item)) {
                    checked = true
                    break
                } else {
                    continue
                }
            }
            if (checked) {
                if (event.target.files[0].size > 2097152) {
                    alert('2MB 이하만 업로드 가능합니다.')
                    this.$refs.secondFile.value = ''
                    this.selectedSecondFiles = ''
                    return false
                }

                this.completeSecondFile = event.target.files[0];
                this.selectedSecondFileName = event.target.files[0].name;
                this.buttonFileDelete2 = false;
                this.$refs.secondFile.value = ''
            } else {
                alert('파일 포맷은 pdf, pptx, docx, xlsx, hwp, jpg, png형식만 가능합니다.')
                this.$refs.secondFile.value = ''
                this.selectedSecondFiles = ''
                return false
            }
        },

        isViewDownPostion() {
            if (this.selectedFirstFileName || this.selectedSecondFileName) {
                return true
            } else {
                return false
            }
        },

        /**
         * @param {String} buttonType 다운로드 버튼 1,2
         * @description : deleteFile
         */
        deleteFile(/* 다운로드 버튼 종료 */buttonType){
            if(buttonType === 'button1'){
                this.completeFirstFile = '';
                this.buttonName1 = '';
                this.selectedFirstFileName = '';
                this.buttonFileDelete1 = true;
            }
            else if(buttonType === 'button2'){
                this.completeSecondFile ='';
                this.buttonName2 = '';
                this.selectedSecondFileName = '';
                this.buttonFileDelete2 = true;
            }
        },

        async save() {
            let formData = new FormData();

            formData.append('mainIdx', sessionStorage.getItem('mainIdx'));

            formData.append('buttonName1', this.buttonName1);
            formData.append('buttonName2', this.buttonName2);
            formData.append('buttonPosition', this.buttonPosition);
            formData.append('guideContents', this.editorData);
            formData.append('buttonFileDelete1', this.buttonFileDelete1);
            formData.append('buttonFileDelete2', this.buttonFileDelete2);

            if (this.selectedFirstFileName !== '') {
                if (!this.buttonName1) {
                    alert('다운로드 버튼1의 이름을 입력하세요.')
                    return false
                }

                if (this.buttonName1.trim() === '') {
                    alert('다운로드 버튼1의 이름을 입력하세요.')
                    return false
                }
            }

            if (this.selectedSecondFileName !== '') {
                if (!this.buttonName2) {
                    alert('다운로드 버튼2의 이름을 입력하세요.')
                    return false
                }

                if (this.buttonName2.trim() === '') {
                    alert('다운로드 버튼2의 이름을 입력하세요.')
                    return false
                }
            }

            if (this.completeFirstFile === '') {
                formData.append('buttonFile1', new Blob(),'');
            } else {
                formData.append('buttonFile1', this.completeFirstFile);
            }

            if (this.completeSecondFile === '') {
                formData.append('buttonFile2', new Blob(), '')
            } else {
                formData.append('buttonFile2', this.completeSecondFile);
            }

            if (this.completeSecondFile === '' && this.completeFirstFile === '') {
                formData.delete('buttonPosition');
            }

            let headers = {
                'Content-Type': 'multipart/form-data',
                'Access-Control-Allow-Origin': '*'
            }

            for (var key of formData.entries()) {
                console.log(key[0] + ', ' + key[1])
            }

            await this.axios.put(this.axios.root + this.axios.port + '/sugang/guide', formData, headers)
                .then(res => {
                    console.log('res', res)
                    if (res.data.err === 0) {
                        this.isSaved = true
                        alert('저장되었습니다.')
                    }
                })
        }
    }
}
</script>
